import type { Drop } from '@/types';

import styles from './ArchiveDropCell.module.css';

interface ArchiveDropCellProps {
  drop: Drop;
}

export default function ArchiveDropCell({ drop }: ArchiveDropCellProps) {
  return (
    <article className={styles.root} data-state={drop.state}>
      <span className={styles.code}>DROP / {drop.id}</span>
      <span className={styles.state}>{drop.state.toUpperCase()}</span>
      <span className={styles.name}>{drop.title}</span>
      <span className={styles.sub}>{drop.subtitle}</span>
      <span className={styles.code}>
        {drop.release} · {drop.items} OBJECTS
      </span>
    </article>
  );
}
